import { render, staticRenderFns } from "./organismemodale.vue?vue&type=template&id=6d737f87&scoped=true"
import script from "./organismemodale.vue?vue&type=script&lang=js"
export * from "./organismemodale.vue?vue&type=script&lang=js"
import style0 from "./organismemodale.vue?vue&type=style&index=0&id=6d737f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d737f87",
  null
  
)

export default component.exports